import React from "react";
import { withFormsy } from "formsy-react";
import Select from "react-select";
import ErrorLabel from "../../../common/errorLabel";
import Tooltip from "../../../common/tooltip";

class FormSelect extends React.Component {
  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(selectedOption) {
    this.props.setValue(selectedOption && selectedOption[this.props.valueKey]);
  }

  render() {
    const errorMessage = this.props.getErrorMessage();
    const {
      options,
      valueKey,
      labelKey,
      showRequired,
      onChange,
      showError,
      getValue,
      name,
      description,
      label,
      isPristine,
      disableFields,
      isRequired
    } = this.props;
    const hasError = !isPristine() && showError();
    const requiredError = showRequired() && !isPristine();
    return (
      <div className="form-group">
        <label
          className={`input-control-label ${isRequired() ? "required" : ""}`}
          htmlFor={name}
        >
          {label}{" "}
          {description && (
            <Tooltip message={description} position={"bottom"}>
              (?)
            </Tooltip>
          )}
        </label>
        <Select
          value={getValue() || ""}
          className={hasError || requiredError ? "error" : ""}
          options={options}
          name={name}
          onChange={onChange || this.changeValue}
          valueKey={valueKey}
          labelKey={labelKey}
          disabled={disableFields}
        />
        <ErrorLabel message={hasError ? errorMessage : ""} />
        <ErrorLabel message={requiredError ? "Required" : ""} />
      </div>
    );
  }
}

export default withFormsy(FormSelect);



// WEBPACK FOOTER //
// ./src/components/discover/common/controls/Select.js